import { apiCall } from './_helper';

//--------Functions for retrieving ENS data from the API--------//

// Fetches a list of companies to submit ENS data for
// Tested and working: 4/6/2025
export const getCompaniesForDropdown = async () => {
  return await apiCall({
    url: 'dashboard/getCompaniesForDropdown',
    reportingUrl: true,
    notJSON: true,
  });
};
// Fetches details of a specific ENS by its ID
// Tested & Working: 4/6/2025
export const getENSDetails = async (id) => {
  return await apiCall({
    url: `ens/getENSDetails/${id}`,
    notJSON: true,
  });
};

//--------Functions for submitting ENS data to the API--------//

// Submits a new ENS header with the provided data, or updates existing T&J data
// Tested & Working: 4/6/2025 - Both new and update functionality
export const PostTransportAndJourney = async (data, companyId) => {
  const companyIdOrEmptyString = companyId ? `?companyId=${companyId}` : '';
  return await apiCall({
    url: `ens/transportJourney${companyIdOrEmptyString}`,
    method: 'POST',
    body: JSON.stringify(data),
  });
};

// Submits a new consignment
// Tested & Working: 4/6/2025
export const PostConsignment = async (data) => {
  return await apiCall({
    url: 'ens/consignments',
    method: 'POST',
    body: JSON.stringify(data),
  });
};

// Submits additional details for an ENS
// Tested & Working: 4/6/2025
export const PostAdditionalDetails = async (data) => {
  return await apiCall({
    url: 'ens/additionalDetails',
    method: 'POST',
    body: JSON.stringify(data),
  });
};

// Submits the ENS created in the previous steps of this section
// Tested & Working: 4/6/2025
export const SubmitENS = async (headerId) => {
  return await apiCall({
    url: `ens/sendICSENS/` + headerId,
    notJSON: true,
  });
};
//--------Specific functions for submitting ENS data--------//
export const postENSXMLFile = async (fileText, companyId) => {
  return apiCall({
    url: `ens/fileupload/xml/${companyId}`,
    method: 'POST',
    body: fileText,
    notJSON: true,
    headers: {
      'Content-Type': 'application/xml',
    },
  });
};

// Fetches MRN details based on the provided MRN
export const getMRNDetails = async (mrn) => {
  return apiCall({
    url: `ens/getMRNDetails/${encodeURIComponent(mrn)}`,
    throwOnError: true,
    errorMessage: 'There was an error fetching MRN details',
  });
};

//-------More global functions for manipulating ENS data-------//

// Deletes a consignment based on the provided consignmentId(s)
// Tested & Working: 4/6/2025
export const handleDeleteConsignment = async (consignmentId) => {
  return apiCall({
    url: `ens/deleteConsignment`,
    method: 'DELETE',
    body: {
      consignmentIds: Array.isArray(consignmentId) ? '' + consignmentId.join(', ') : consignmentId.toString(),
    },
    stringify: true,
    onSuccess: () => ({ message: 'Consignment deleted' }),
    errorMessage: 'There was an error deleting the consignment',
  });
};

// Deletes a shipment based on the provided shipmentId
// Tested & Working: 4/6/2025
export const deleteShipment = async (shipmentId) => {
  return await apiCall({
    url: `ens/deleteShipment?headerId=${shipmentId}`,
    method: 'DELETE',
    notJSON: true,
  });
};

// Cancels a shipment based on the provided shipmentId
// Tested & Working: 4/6/2025
export const cancelShipment = async (shipmentId) => {
  return await apiCall({
    url: `ens/cancelShipment?headerId=${shipmentId}`,
    method: 'DELETE',
    notJSON: true,
  });
};

// Duplicates a shipment based on the provided headerId and jobReference
// Tested & Working: 4/6/2025
export const duplicateShipment = async (headerId, jobReference) => {
  return await apiCall({
    url: 'ens/duplicateShipment',
    method: 'POST',
    body: JSON.stringify({ headerId, jobReference }),
  });
};

export const amendShipment = async (headerId) => {
  return await apiCall({
    url: 'ens/ammendShipment',
    method: 'POST',
    body: JSON.stringify({ headerId }),
  });
};

// Refresh the status of a shipment based on consignments status
export const refreshShipmentStatus = async (headerId) => {
  return await apiCall({
    url: 'ens/refreshStatus',
    method: 'POST',
    body: JSON.stringify({ headerId }),
  });
};
